import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState: {
  parent_listingWithActivityListData: any;
  parent_listingWithActivityListLoading: boolean;
  parent_listingWithActivityListError: SerializedError | null;
} = {
  parent_listingWithActivityListData: {},
  parent_listingWithActivityListLoading: false,
  parent_listingWithActivityListError: null,
};

export const parent_listingWithActivityListFunc = createAsyncThunk(
  'parent_listingWithActivityList/parent_listingWithActivityListFunc',
  async (values: { listingId: string }) => {
    const accessTokenJSON = localStorage.getItem('auth') as string;
    const data1 = JSON.stringify({
      query: `query Parent_listingWithActivityList($listingId: String!) {
  parent_listingWithActivityList(listingId: $listingId) {
    _id
    activities {
      _id
      title
      listing {
        _id
        title
        category
        subCategory
        ageInterval
        format
        description
        images
        coverImage
        companionship
        rating {
          average
          numberOfReviews
          createdAt
          updatedAt
        }
        reviews {
          count
          data {
            _id
            ratedModel {
              _id
            }
            ratedRefModel
            title
            comment
            purposeType
            rating
            createdAt
            updatedAt
          }
        }
        exteriorOrganizer {
          _id
          name
          imageUrl
          details
          socialMedia {
            website
            instagram
            twitter
            facebook
            youtube
          }
          contact {
            phoneNumber
            phoneNumber2
          }
          createdAt
          updatedAt
        }
      }
      schedule {
        _id
        repeatedIntervalType
        startDate
        endDate
        totalDayCount
        days {
          _id
          activity {
            _id
          }
          date
          day
          startTime
          endTime
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      location {
        _id
        city
        district
        country
        address {
          title
          description
        }
        lat
        long
        parking
      }
      additionalDetails
      quota
      hoursBeforeReservationExpires
      fee
      isReservationRequired
      externalLink
      externalMail
      externalPhoneNumber
      price
      duration
      status
      reservation {
        _id
        activity {
          _id
          title
          listing {
            _id
            title
            category
            subCategory
            ageInterval
            format
            description
            images
            coverImage
            companionship
            status
            rejectionDetail
          }
          location {
            _id
            city
            district
            country
            lat
            long
            parking
            status
            rejectionDetail
          }
          additionalDetails
          quota
          hoursBeforeReservationExpires
          fee
          isReservationRequired
          reservationType
          externalLink
          externalMail
          externalPhoneNumber
          price
          duration
          status
          priority
          createdAt
          updatedAt
        }
        parent {
          _id
          displayName
          displayImageUrl
          description
          role
        }
        status
        imageUrl
        cancellationInformation {
          _id
          description
          at
          createdAt
          updatedAt
        }
        rejectionInformation {
          _id
          description
          at
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      likedByParent
      participantCount
      priority
      createdAt
      updatedAt
      createdBy {
        _id
        displayName
        displayImageUrl
        description
        role
      }
      updatedBy {
        _id
        displayName
        displayImageUrl
        description
        role
      }
    }
  }
}`,
      variables: {
        listingId: values?.listingId ?? null,
      },
    });

    const config = initialConfig(
      process.env.REACT_APP_BASE_URL_ACTIVITY || '',
      data1,
      JSON.parse(accessTokenJSON)?.accessToken || ''
    );

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const parent_listingWithActivityList = createSlice({
  name: 'parent_listingWithActivityList',
  initialState,
  reducers: {
    clearParentListingWithActivityListData: (state) => {
      state.parent_listingWithActivityListData = {};
      state.parent_listingWithActivityListError = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(parent_listingWithActivityListFunc.pending, (state) => {
      state.parent_listingWithActivityListLoading = true;
    });
    builder.addCase(parent_listingWithActivityListFunc.fulfilled, (state, action) => {
      state.parent_listingWithActivityListLoading = false;

      // Detay sayfası için tüm aktiviteleri göster (filtreleme yapma)
      // Bu query detay sayfasında kullanıldığı için tüm aktiviteleri döndürmeliyiz
      const data = action.payload?.data?.parent_listingWithActivityList;
      state.parent_listingWithActivityListData = data || {};

      state.parent_listingWithActivityListError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(parent_listingWithActivityListFunc.rejected, (state, action) => {
      state.parent_listingWithActivityListLoading = false;
      state.parent_listingWithActivityListError = action.error;
    });
  },
});

export const { clearParentListingWithActivityListData } = parent_listingWithActivityList.actions;
export default parent_listingWithActivityList.reducer;
